export enum UIState {
  Idle,
  Connecting,
  Connected,
}
